<mat-sidenav-container
  class="oc-sidenav__container"
  (backdropClick)="toggleSidenavGeneralState()"
  autosize
  octWindowWidthDetector
  (breakpointExceeded)="handleWindowWidthStatus($event)">
  <mat-sidenav
    #sidenav
    [mode]="modeSidenav"
    [opened]="sidenavGeneralState()"
    class="oc-sidenav"
    [@animationSidenavState]="sidenavOpenedState()"
    (@animationSidenavState.done)="animationDone()"
    [ngClass]="{
      'oc-sidenav--close': !sidenavOpenedState() && sidenavGeneralState(),
      'oc-sidenav--general-close': !sidenavGeneralState() && !sidenavOpenedState()
    }"
    [disableClose]="true"
    [fixedInViewport]="true"
    [fixedTopGap]="0"
    [fixedBottomGap]="0">
    <div class="oc-sidenav__header-menu__wrapper">
      <div
        class="oc-sidenav__header"
        [ngClass]="{
          'oc-sidenav__header--open': sidenavOpenedState(),
          'oc-sidenav__header--close': !sidenavOpenedState() && sidenavGeneralState(),
          'oc-sidenav-header--over': modeSidenav === navigationMode.over
        }">
        <a href="" class="oc-sidenav__logo-link">
          @if (sidenavOpenedState && sidenavGeneralState() && modeSidenav !== navigationMode.over && companyData()?.attributes?.logo) {
            <img [src]="companyData().attributes.logo" class="oc-sidenav__logo-image" alt="" />
          }
        </a>
        @if (modeSidenav === navigationMode.over) {
          <button mat-icon-button class="oc-sidenav__icon-close" (click)="toggleSidenavGeneralState()">
            <mat-icon>cancel</mat-icon>
          </button>
        } @else {
          <button mat-icon-button (click)="toggleSidenavState()" class="oc-sidenav__action-icon">
            <div class="oc-icon" [class.is-open]="sidenavOpenedState()">
              <div class="oc-icon__line"></div>
              <div class="oc-icon__line"></div>
              <div class="oc-icon__line"></div>
            </div>
          </button>
        }
      </div>
      <ng-content select="oct-menu" class="oc-sidenav__tree-menu" />
    </div>

    <div class="oc-sidenav__footer">
      @if (currentUser()?.attributes?.name) {
        <div class="oc-avatar" [class.is-collapsed]="!sidenavOpenedState()">
          <a
            class="oc-avatar__image-link"
            (click)="navigateToAccount()"
            #tooltip
            [matTooltip]="'Your profile'"
            [matTooltipPosition]="'above'"
            [matTooltipDisabled]="disableTooltip()"
            [matTooltipClass]="'oc-sidenav-tooltip'">
            @if (!image() && !currentUser()?.attributes?.image) {
              <div class="oc-avatar__placeholder">
                {{ currentUser()?.attributes.name | initials }}
              </div>
            }
            @if (image() || currentUser()?.attributes?.image) {
              <img class="oc-avatar__placeholder" [src]="image() || currentUser().attributes.image" alt="" />
            }
          </a>
          @if (sidenavOpenedState()) {
            <div
              class="oc-avatar__wrapper"
              [matTooltip]="companies()?.length > 1 ? 'Switch company' : ''"
              [matTooltipPosition]="'above'"
              [matTooltipClass]="'oc-sidenav-tooltip-right'"
              [matTooltipDisabled]="disableTooltip()">
              <div class="oc-avatar__name">{{ currentUser().attributes.name }}</div>
              @if (companies()?.length > 1) {
                <p class="oc-avatar__company" [matMenuTriggerFor]="menuSelectCompanyState">
                  @if (companyData()?.attributes?.name) {
                    <a class="oc-avatar__company-name">
                      {{ companyData().attributes.name }}
                    </a>
                  }
                  <mat-icon class="oc-avatar__company-icon">arrow_drop_down</mat-icon>
                </p>
              }
            </div>
          }
        </div>
      }

      <mat-menu #menuSelectCompanyState="matMenu" class="oc-sidenav__select-company">
        @if (companies()?.length > 1) {
          @for (company of companies(); track company.id) {
            <button
              mat-menu-item
              [ngClass]="{'is-active': company.attributes.urlPrefix === urlPrefix()}"
              (click)="toggleCompany(company)"
              class="oc-sidenav__company-button">
              {{ company.attributes.name }}
            </button>
          }
        }
      </mat-menu>
    </div>
  </mat-sidenav>

  <mat-sidenav-content
    class="oc-sidenav__content"
    [ngClass]="{
      'oc-sidenav__content--open': sidenavOpenedState(),
      'oc-sidenav__content--close': !sidenavOpenedState() && sidenavGeneralState(),
      'oc-sidenav__content--over': modeSidenav === navigationMode.over
    }">
    @if (modeSidenav === navigationMode.over) {
      <div class="oc-sidenav__content-header">
        <a class="oc-sidenav__logo-link">
          @if (companyData()?.attributes?.logo) {
            <img [src]="companyData().attributes.logo" class="oc-sidenav__logo-image" alt="" />
          }
        </a>
        <button mat-icon-button (click)="toggleSidenavGeneralState()" class="oc-sidenav__action-icon">
          <div class="oc-icon" [class.is-open]="!sidenavGeneralState()">
            <div class="oc-icon__line"></div>
            <div class="oc-icon__line"></div>
            <div class="oc-icon__line"></div>
          </div>
        </button>
      </div>
    }
    <ng-content select="[body]" />
  </mat-sidenav-content>
</mat-sidenav-container>
